module.exports = __webpack_public_path__ + "static/media/SG-SMT1_1AQlOkPrE3UFy-AHWUerfe-Whr4EmWcCl.edfd1d63.bin";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photos/SG-SMT1_1AQlOkPrE3UFy-AHWUerfe-Whr4EmWcCl
// module id = 664
// module chunks = 0